// extracted by mini-css-extract-plugin
export default {"productGrid":"Z1-z","centerLink":"_1-z","productSection":"a2-z","item":"b2-z","ctaButton":"c2-z"};